import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { CardContent, Typography } from "@mui/material"
import { IAttachment } from "../../common/models/IAttachment"
import { ObjectAttachmentCard } from "./ObjectAttachmentCard"
import { faFileExcel, faFilePdf, faFileImage, faFileWord, faFileCode, faFileText } from "@elynx/free-regular-svg-icons";
import { format } from "date-fns/format";
import { ObjectAttachmentCardHeader } from "./ObjectAttachmentCardHeaderProps"
import { ApplicationMimeTypesEnum } from "../../common/enums/ApplicationMimeTypesEnum"
import { faPaperclip } from "@elynx/free-solid-svg-icons"
import { ActionMenuItem } from "../action-menu/ActionMenuItem"
import ActionMenu from "../action-menu/ActionMenu"
import { useTranslation } from "react-i18next"
import { IeLynxObject } from "../../common/models/eLynxObject";

export type ObjectAttachmentItemProps = {
    item?: IAttachment | undefined; // Switch to IObjectAttachment?
    readOnly?: boolean;
    contextObject?: IeLynxObject;
    onAction: (action: ObjectAttachmentItemActionEnum, item: IAttachment) => void;
}

export enum ObjectAttachmentItemActionEnum {
    Download = 1,
    Delete = 2
}

export function ObjectAttachmentItem({ item, readOnly, contextObject, onAction}: ObjectAttachmentItemProps) {
    const { t } = useTranslation();

    const actionItems = new Array<ActionMenuItem>();
    if (item) {
        actionItems.push({
            label: t('actions.download'),
            onClick: () => {
                onAction && onAction(ObjectAttachmentItemActionEnum.Download, item);
            }
        });

        actionItems.push({
            label: t('actions.delete'),
            disabled: readOnly,
            onClick: () => {
                onAction && onAction(ObjectAttachmentItemActionEnum.Delete, item);
            }
        })
    }

    const lastModified = item?.lastModified
        ? format(new Date(item.lastModified), "P pp")
        : "";

    return (
        <ObjectAttachmentCard>
            <ObjectAttachmentCardHeader
                title={lastModified}
                avatar={
                    item?.mimeType === ApplicationMimeTypesEnum.PDF
                        ? <FontAwesomeIcon icon={faFilePdf} size="2x" />
                        : item?.mimeType === ApplicationMimeTypesEnum.JPEG || item?.mimeType === ApplicationMimeTypesEnum.GIF || item?.mimeType === ApplicationMimeTypesEnum.PNG || item?.mimeType === ApplicationMimeTypesEnum.Bitmap
                            ? <FontAwesomeIcon icon={faFileImage} size="2x" />
                            : item?.mimeType === ApplicationMimeTypesEnum.MSWord || item?.mimeType === ApplicationMimeTypesEnum.MSWord2007
                                ? <FontAwesomeIcon icon={faFileWord} size="2x" />
                                : item?.mimeType === ApplicationMimeTypesEnum.MSExcel || item?.mimeType === ApplicationMimeTypesEnum.MSExcel2007
                                    ? <FontAwesomeIcon icon={faFileExcel} size="2x" />
                                    : item?.mimeType === ApplicationMimeTypesEnum.HTMLText || item?.mimeType === ApplicationMimeTypesEnum.XMLText
                                        ? <FontAwesomeIcon icon={faFileCode} size="2x" />
                                        : item?.mimeType === ApplicationMimeTypesEnum.TXT
                                            ? <FontAwesomeIcon icon={faFileText} size="2x" />
                                            : <FontAwesomeIcon icon={faPaperclip} size="2x" />
                }
                subheader={
                    <>
                        {item?.fileName}
                    </>
                }
                action={<ActionMenu actionItems={actionItems} />}
            >
            </ObjectAttachmentCardHeader>
            <CardContent sx={{
                padding: (theme) => `0 ${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(1)} !important`,
            }}>
                <Typography variant="body2" noWrap={false}>
                    {item?.description}
                </Typography>
            </CardContent>
        </ObjectAttachmentCard>
    )
}